export enum TaskType {
  FARROWING = 'farrowing' as any,
  INSEMINATION = 'insemination' as any,
  TOUCHING = 'check-touching' as any,
  WEIGHING3 = 'weighing3' as any,
  WEIGHING4 = 'weighing4' as any,
  WEIGHING_3RDYEAN = 'weighing_3rdyean' as any,
}
